export default __webpack_public_path__ + "static/media/logo.6b0e3097.png";